import { deepExtract } from 'helpers/deep';

export const SHOW_SELF_SERVE = 'classpass/Cancel/SHOW_SELF_SERVE';
export const SHOW_CANCEL_FORM = 'classpass/Cancel/SHOW_CANCEL_FORM';

export const showSelfServe = () => ({ type: SHOW_SELF_SERVE });
export const showCancelForm = () => ({ type: SHOW_CANCEL_FORM });

export const selectIsSelfServe = deepExtract.bind(null, 'features.cancel.isSelfServe');
export const selectIsCancelForm = deepExtract.bind(null, 'features.cancel.isCancelForm');

const initialState = {
  isSelfServe: false,
  isCancelForm: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_SELF_SERVE:
      return {
        ...state,
        isSelfServe: true,
      };
    case SHOW_CANCEL_FORM:
      return {
        ...state,
        isCancelForm: true,
      };
    default:
      return state;
  }
}
